<template>
  <b-card
      title="مدیریت نمایشگاه ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 mr-auto ml-1"
                  variant="primary"
                  :to="{ name: 'addexhibition'}"
              >
                جدید
              </b-button>

              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                      :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                      :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
            :sort-by="filterOptions.SortBy"
            :sort-desc="filterOptions.IsDesc"
            @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'updateexhibition', params: { id: data.value }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Title)="data">
            <span class="text-nowrap">
              <b-avatar
                  class="mr-1"
                  :src="data.item.Image"
              />
              {{ data.value }}
            </span>
          </template>

          <template #cell(StartDate)="data">
            {{ data.value | date }}
          </template>

          <template #cell(EndDate)="data">
            {{ data.value | date }}
          </template>

          <template #cell(City)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(State)="data">
            {{ data.item.City.State.Title }}
          </template>

          <template #cell(IsActive)="data">
            <b-badge
                :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'updateexhibition', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon

                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'Exhibition',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        Type: 0,
        SortBy: 'Id',
        IsDesc: true,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'StartDate',
          label: 'تاریخ شروع',
          sortable: true,
        },
        {
          key: 'EndDate',
          label: 'تاریخ پایان',
          sortable: true,
        },
        {
          key: 'State',
          label: 'استان',
        },
        {
          key: 'City',
          label: 'شهر',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.exhibition.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
          this.$api.exhibition.clearcache, null,
      )
          .then(res => {
            this.update()
          })
    },
    remove(id) {
      this.removeRow(this.$api.exhibition.remove, 'Id', id)
    },
  },
}
</script>

<style scoped>

</style>